import React, { useEffect, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { FiMapPin, FiPhone, FiHome, FiCalendar, FiUsers, FiTag, FiClock } from 'react-icons/fi'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import apiInstance from '../../../../../Utils/api'
import BranchBadge from '../shared/BranchBadge'
import BranchButton from '../shared/BranchButton'
import BranchBreadcrumb from '../shared/BranchBreadcrumb'
import '../branch.css'

export default function BranchDetail() {
  const location = useLocation()
  const ID = location.pathname.split('/')[2]
  const [branch, setBranch] = useState(null)

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await apiInstance.get('v2/branch/' + ID)
        setBranch(res.data.data)
      } catch (err) {
        console.error(err)
      }
    }
    fetchDetail()
  }, [ID])

  if (!branch) {
    return (
      <div className='branch-page'>
        <div className='branch-empty'>
          <div className='branch-empty-title'>Loading...</div>
        </div>
      </div>
    )
  }

  const bannerUrl = branch.imageUrls?.[0]

  return (
    <div className='branch-page'>
      <BranchBreadcrumb items={[
        { label: 'Branches', to: '/branch' },
        { label: branch.name }
      ]} />

      {/* HERO CARD */}
      <div className='branch-hero'>
        {bannerUrl ? (
          <PhotoProvider>
            <PhotoView src={bannerUrl}>
              <img className='branch-hero-banner' src={bannerUrl} alt={branch.name} style={{ cursor: 'pointer' }} />
            </PhotoView>
          </PhotoProvider>
        ) : (
          <div className='branch-hero-banner-placeholder'>
            <FiHome />
          </div>
        )}
        <div className='branch-hero-content'>
          <div className='branch-hero-info'>
            <h1>{branch.name}</h1>
            {branch.displayName && <div style={{ fontSize: '0.9em', color: '#94a3b8', marginTop: -4, marginBottom: 8 }}>{branch.displayName}</div>}
            <BranchBadge status={branch.isDeleted ? 'Deleted' : 'Active'} />
          </div>
          <div className='branch-hero-stats'>
            <div className='branch-hero-stat'>
              <div className='branch-hero-stat-value'>-</div>
              <div className='branch-hero-stat-label'><FiUsers size={14} /> Staff</div>
            </div>
            <div className='branch-hero-stat'>
              <div className='branch-hero-stat-value'>-</div>
              <div className='branch-hero-stat-label'><FiTag size={14} /> Promotions</div>
            </div>
            <div className='branch-hero-stat'>
              <div className='branch-hero-stat-value'>-</div>
              <div className='branch-hero-stat-label'><FiCalendar size={14} /> Appointments</div>
            </div>
          </div>
        </div>
      </div>

      {/* INFO GRID */}
      <div className='branch-info-grid'>
        <div className='branch-info-card'>
          <div className='branch-info-card-title'>Contact Information</div>
          <div className='branch-info-row'>
            <FiPhone className='branch-info-icon' />
            <div>
              <div className='branch-info-label'>Phone Numbers</div>
              <div className='branch-info-content'>
                {branch.phones?.length > 0
                  ? branch.phones.join(', ')
                  : 'Not provided'}
              </div>
            </div>
          </div>
          <div className='branch-info-row'>
            <FiMapPin className='branch-info-icon' />
            <div>
              <div className='branch-info-label'>Address</div>
              <div className='branch-info-content'>{branch.address || 'Not provided'}</div>
            </div>
          </div>
          {branch.openHoursDisplay && (
            <div className='branch-info-row'>
              <FiClock className='branch-info-icon' />
              <div>
                <div className='branch-info-label'>Opening Hours</div>
                <div className='branch-info-content'>{branch.openHoursDisplay}</div>
              </div>
            </div>
          )}
          {branch.closedDays && (
            <div className='branch-info-row'>
              <FiCalendar className='branch-info-icon' />
              <div>
                <div className='branch-info-label'>Closed Days</div>
                <div className='branch-info-content'>{branch.closedDays}</div>
              </div>
            </div>
          )}
        </div>

        <div className='branch-info-card'>
          <div className='branch-info-card-title'>Location</div>
          <div className='branch-info-content' style={{ marginBottom: 12 }}>
            <FiHome className='branch-info-icon' style={{ display: 'inline', marginRight: 6 }} />
            {branch.address || 'Not provided'}
          </div>
          {branch.location?.lat && branch.location?.lng && (
            <div style={{ marginBottom: 12 }}>
              <div className='branch-info-label' style={{ marginBottom: 4 }}>Coordinates</div>
              <div className='branch-info-content'>{branch.location.lat}, {branch.location.lng}</div>
            </div>
          )}
          <div className='branch-map-placeholder'>
            {branch.location?.lat && branch.location?.lng ? (
              <a
                href={`https://www.google.com/maps?q=${branch.location.lat},${branch.location.lng}`}
                target='_blank'
                rel='noopener noreferrer'
                className='branch-btn branch-btn-primary'
                style={{ textDecoration: 'none', display: 'inline-block' }}
              >
                <FiMapPin style={{ marginRight: 6 }} />
                View on Google Maps
              </a>
            ) : (
              'Map integration placeholder'
            )}
          </div>
        </div>
      </div>

      <div style={{ marginTop: 24, display: 'flex', gap: 12 }}>
        <Link to='/branch'>
          <BranchButton variant='outline'>Back to List</BranchButton>
        </Link>
        <Link to={'/branch-update/' + branch._id}>
          <BranchButton>Edit Branch</BranchButton>
        </Link>
      </div>
    </div>
  )
}
